module.exports = __webpack_public_path__ + "img/icon-gold50.a6d49286.png";